import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Parser from "html-react-parser";
import { useMutation } from "urql";
import {
  Alert,
  Box,
  Button,
  Stack
} from "@mui/material";

export default function TermsOfService() {
  const location = useLocation();
  const { state } = location;
  const terms = state?.contentOfTerms;
  const [content, setContent] = useState("");
  const [button, setButton] = useState("");
  const [alert, setAlert] = useState(false);
  const [language, setLanguage] = useState("JP");
  const [error, setError] = useState("利用規約への同意に失敗しました");
  const [disabled, setDisabled] = useState(true);

  const navigate = useNavigate();
  const [_, executeMutation] = useMutation( `mutation updateAcceptDate { updateAcceptDate }` );

  const changeLanguage = () => {
    switch (language) {
      case "JP":
        setContent(terms?.content || '')
        setButton(terms?.button || '')
        setError("利用規約への同意に失敗しました")
        break
      case "EN":
        setContent(terms?.contentEn || '')
        setButton(terms?.buttonEn || '')
        setError("Failed to accept the terms of service")
        break
    }
  };

  useEffect(() => {
    changeLanguage();
  }, [terms]);
  useEffect(() => {
    changeLanguage();
  }, [language]);

  const handleScroll = (e: React.UIEvent<HTMLElement>) => {
    const target = e.target as HTMLElement;
    if (Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) <= 15) {
      setDisabled(false);
    }
  };

  const handleSubmit = () => {
    setAlert(false);
    if (disabled) {
      setAlert(true);
      return;
    } else {
      executeMutation().then((res) => {
        if (res.error) {
          setAlert(true);
          return;
        }
        navigate("/", { replace: true });
      }).catch(() => {
        setAlert(true);
      });
    }
  };

  return (
    <Box
      sx={{
        margin: '0 auto',
        maxWidth: '800px',
        height: '100%',
        boxSizing: 'border-box',
        padding: '20px',
        whiteSpace: 'wrap',
        wordBreak: 'break-word',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {alert && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Stack direction="row" gap={2}>
        <Button
          type="button"
          color="primary"
          variant="contained"
          onClick={() => setLanguage("JP")}
        >
          {"日本語"}
        </Button>
        <Button
          type="button"
          color="primary"
          variant="contained"
          onClick={() => setLanguage("EN")}
        >
          {"English"}
        </Button>
      </Stack>
      <Box
        className="ql-editor"
        sx={{
          margin: '20px 0',
          overflowY: 'auto',
        }}
        onScroll={handleScroll}
      >
        {Parser(String(content))}
      </Box>
      <Box
        sx={{
          width: '100%',
          textAlign: 'center',
        }}
      >
        <Button
          type="button"
          color="primary"
          variant="contained"
          disabled={disabled}
          onClick={handleSubmit}
        >
          {button}
        </Button>
      </Box>
    </Box>
  )
}
